module.exports = __webpack_public_path__ + "img/score.ad5d9c9d.png";